// extracted by mini-css-extract-plugin
export default {"avatarField":"AvatarFormComponent_avatarField__hXlL5","avatarUploadForm":"AvatarFormComponent_avatarUploadForm__LCUrW"};